import type { DashboardMetadataResource } from "@/types_api/backend/transport/list_dashboard_metadata_response"
import { resourceNameIssue } from "@/utils/validation/resourceName"

export const DASHBOARD_NAME_MAX_LENGTH = 255

export function dashboardDisplayName(
  dashboard: Pick<DashboardMetadataResource, "display_name" | "is_default">,
) {
  return (
    dashboard.display_name?.trim() ||
    (dashboard.is_default ? "Main" : "Untitled")
  )
}

export function dashboardNameValidationIssue(name: string) {
  return resourceNameIssue(name, {
    resource: "dashboard",
    maxLength: DASHBOARD_NAME_MAX_LENGTH,
  })
}

/**
 * The names other dashboards have stored, for a duplicate-name check. A dashboard with no stored name contributes nothing: its "Main" or "Untitled" label is a display fallback, not a name another dashboard could collide with.
 *
 * @param dashboards The organization's dashboard list as the transport returns it.
 * @param excludeId The dashboard being renamed.
 * @returns The trimmed stored names of every other dashboard.
 */
export function storedDashboardNames(
  dashboards: readonly DashboardMetadataResource[] | undefined,
  excludeId: string,
): string[] {
  return (dashboards ?? []).flatMap((dashboard) => {
    const name = dashboard.display_name?.trim()
    return name && dashboard.name.split("/").at(-1) !== excludeId ? [name] : []
  })
}
